import { createAsyncThunk } from "@reduxjs/toolkit";

import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { GetAllDepartments, CreateNewDepartment, UpdateDepartment, DeleteDepartment, AssignDepartmentHead, GetAllEmployees } from "helpers/api_method";

export const getAllDepartmentList = createAsyncThunk("department/getAllDepartmentList", async () => {
    try {
        const response = await GetAllDepartments();
        return response.data;
    } catch (error) {
        return error;
    }
});
export const addNewDepartment = createAsyncThunk("department/addNewDepartment", async (event: any) => {
    try {
        const response = await CreateNewDepartment(event);
        toast.success("Department created Successfully", { autoClose: 2000 });
        return response.data;
    } catch (error) {
        toast.error("Department creation Failed", { autoClose: 2000 });
        return error;
    }
});
export const updateExistingDepartment = createAsyncThunk("department/updateExistingDepartment", async (event: any) => {
    try {
        const response = await UpdateDepartment(event.id, event);
        toast.success("Department updated Successfully", { autoClose: 2000 });
        return response.data;
    } catch (error) {
        toast.error("Department updated Failed", { autoClose: 2000 });
        return error;
    }
});
export const updateDepartmentHeadID = createAsyncThunk("department/updateDepartmentHeadID", async (event: any) => {
    try {
        const response = await AssignDepartmentHead(event.department_id, event);
        toast.success("Department Head assigned Successfully", { autoClose: 2000 });
        return response.data;
    } catch (error) {
        toast.error("Department Head assign Failed", { autoClose: 2000 });
        return error;
    }
});
export const deleteExistingDepartment = createAsyncThunk("department/deleteExistingDepartment", async (event: any) => {
    try {
        const response = await DeleteDepartment(event.id);
        toast.success("Department deleted Successfully", { autoClose: 2000 });
        return response.data;
    } catch (error) {
        toast.error("Department deletion Failed", { autoClose: 2000 });
        return error;
    }
});

export const getAllDepartmentUsers = createAsyncThunk("department/getAllDepartmentUsers", async () => {
    try {
        const response = await GetAllEmployees();
        return response.data;
    } catch (error) {
        return error;
    }
});